import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import Modal from 'react-modal';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { GameController } from '@mental-mint/shared-ui/GameController/GameController';
import { Game } from '@mental-mint/shared-ui/Store/gameSessionSlice';
import { ErrorBoundary } from '@mental-mint/shared-ui';
import { GameId } from '@mental-mint/shared-types';
import {
  initializeAnalytics,
  initializeGrowthBook,
  getGrowthBook,
} from '@mental-mint/shared-utils';
import { store } from './store';
import { getCraftegoryGame } from './GameSettings';
import ClipLoader from 'react-spinners/ClipLoader';
import './index.css';

Modal.setAppElement('#root');

initializeAnalytics(GameId.Craftegory);
initializeGrowthBook();

function App() {
  const [gameConfig, setGameConfig] = useState<Game | null>(null);

  useEffect(() => {
    const loadGameConfig = async () => {
      const config = await getCraftegoryGame();
      setGameConfig(config);
    };
    loadGameConfig();
  }, []);

  if (!gameConfig) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100dvh',
          backgroundColor: '#0f0f1a',
        }}
      >
        <ClipLoader size={50} color={'#6366f1'} />
      </div>
    );
  }

  return <GameController gameId={GameId.Craftegory} game={gameConfig} />;
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <GrowthBookProvider growthbook={getGrowthBook()}>
        <Provider store={store}>
          <App />
        </Provider>
      </GrowthBookProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
